import React, { useState } from 'react';
import CSSZSickLeaveCertificateReturnAdmissionRequestForm, {
	CSSZSickLeaveCertificateReturnAdmissionRequestFormValues,
} from './CSSZSickLeaveCertificateReturnAdmissionRequestForm';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import moment from 'moment';
import useCSSZSickLeaveForm from '../Hooks/useCSSZSickLeaveForm';
import Loading from '../../../../Components/Loading';
import JobWaiting from '../../../Base/Components/Job/JobWaiting';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateReturnAdmissionRequest: React.FC<Props> = ({
	item,
	patientId,
	onCreate,
}) => {
	const [waitingJobId, setWaitingJobId] = useState<string | null>(null);
	const { showNotificationAlert, showNotificationSuccess } = useNotification();
	const { post, isLoading } = useCSSZSickLeaveForm({
		patientId,
		sickLeaveCertificate: item,
		endpoint: 'zadost-o-zpetne-uznani-pn',
	});

	const handleSubmit = async (
		values: CSSZSickLeaveCertificateReturnAdmissionRequestFormValues,
	) => {
		await post(values, (jobId?: string) => {
			if (jobId) {
				setWaitingJobId(jobId);
			} else {
				onCreate();
			}
		});
	};

	if (waitingJobId) {
		return (
			<JobWaiting
				jobId={waitingJobId}
				onJobSuccess={() => {
					setWaitingJobId(null);
					showNotificationSuccess({
						content:
							'component.CSSZSickLeaveCertificateDetailControls.returnAdmissionRequestSuccess',
					});
					onCreate();
				}}
				onJobFailed={() => {
					setWaitingJobId(null);
					showNotificationAlert({
						content: 'component.jobWaiting.jobFailed',
					});
				}}
				timeout={15000}
				waitingMessage='component.jobWaiting.waitingTitle'
			/>
		);
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CSSZSickLeaveCertificateReturnAdmissionRequestForm
			onSubmit={handleSubmit}
			defaultValues={{
				issuedAt: moment().format(),
			}}
		/>
	);
};

export default CSSZSickLeaveCertificateReturnAdmissionRequest;
